var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1263 1.84169L6.82153 6.14647L6.46798 6.50002L6.82153 6.85357L11.1263 11.1584L10.6584 11.6262L6.35363 7.32147L6.00008 6.96791L5.64653 7.32147L1.34175 11.6262L0.873855 11.1584L5.17864 6.85357L5.53219 6.50002L5.17864 6.14647L0.873855 1.84169L1.34175 1.37379L5.64653 5.67857L6.00008 6.03213L6.35363 5.67857L10.6584 1.37379L11.1263 1.84169Z",
    fill: "black",
    stroke: "#363939"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e12a91768bb10956a170fd67d1f186d2.svg";
export { ForwardRef as ReactComponent };